import React from "react";
import { useTranslation } from "react-i18next";
import FlatbufferMessagePicker from "../select/FlatbufferMessagePicker";
import { FbMessageRef } from "../../../interfaces/FbMessage.interface";

export default function FormFlatbufferMessagePicker({
  value,
  onChange,
  disabled = false,
  label = undefined,
  required = true,
}: {
  value: FbMessageRef | null;
  onChange: (ref: FbMessageRef | null) => void;
  disabled?: boolean;
  label?: string;
  required?: boolean;
}) {
  const [t] = useTranslation("global");
  return (
    <div className="col-md-12 mt-3">
      <div className="generalStyles__flex">
        <div className="generalStyles__inputFlexNameLarge">
          {required && <span className="generalStyles__inputFlexRequired">*</span>}
          <span>{label ?? t("general.message")}</span>
        </div>
        <div className="generalStyles__width100">
          <FlatbufferMessagePicker
            value={value}
            onChange={onChange}
            disabled={disabled}
            allowClear
          />
        </div>
        <div className="generalStyles__infoTooltipIconBlank" />
      </div>
    </div>
  );
}
